import { render, staticRenderFns } from "./SectionItemSameTag.vue?vue&type=template&id=3df5d950&lang=pug&"
import script from "./SectionItemSameTag.vue?vue&type=script&lang=js&"
export * from "./SectionItemSameTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports